/// <reference path="./webp.d.ts" />
/* Los 6 recortes acuarela del menú (PR 8), generados por `scripts/build-nav-icons.mjs`
   desde `docs/design/famindly-2026-09/recursos/referencia-menu-famindly.png`:
   144×144 con alfa, contorno azul marino. Vite les pone hash y quedan en el bundle: la
   app los sirve sin petición de red (BN7).
   El ORDEN de `NAV_ICON_NAMES` es el del menú: Inicio, Chat, Agenda, Tareas, Familia, Perfil. */
import inicio from './inicio.webp'
import chat from './chat.webp'
import agenda from './agenda.webp'
import tareas from './tareas.webp'
import familia from './familia.webp'
import perfil from './perfil.webp'

export const NAV_ICON_NAMES = ['inicio', 'chat', 'agenda', 'tareas', 'familia', 'perfil'] as const
export type NavIconName = (typeof NAV_ICON_NAMES)[number]

/** URL del recorte de día de cada icono. */
export const NAV_ICON_WEBP: Record<NavIconName, string> = { inicio, chat, agenda, tareas, familia, perfil }
